import { h } from "preact";
import Email from "@/assets/icons/email.svg";
import Refresh from "@/assets/icons/refresh.svg";
import { Product } from "@/types/products";
import { trackLinkClick } from "@/utils/adobeAnalytics";
import { useAppContext } from "@/hooks/useAppContext";

const NextSteps = ({ products }: { products: Product[] }) => {
  const mailTo = `mailto:someone@example.com?subject=My CFA Institute Learning Compass results&body=Here%20are%20the%20top%20three%20options%20the%20CFA%20Institute%20picked%20out%20for%20me:%0D%0A%0D%0ATop%20Pick%0D%0A${products[0].name}%0D%0A${products[0].url}%0D%0A%0D%0AOption%20two%0D%0A${products[1].name}%0D%0A${products[1].url}%0D%0A%0D%0AOption%20three%0D%0A${products[2].name}%0D%0A${products[2].url}`;
  const { setAnswers, setActiveStep } = useAppContext();
  const handleReload = (
    e: h.JSX.TargetedEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();

    trackLinkClick("Restart the quiz", "");

    setActiveStep(0);
    setAnswers({});
    window.scrollTo(0, 0);
  };

  return (
    <div className="lc-h-5 lc-justify-center lc-items-center lc-gap-6 lc-inline-flex lc-w-full lc-mt-6 lc-mb-8">
      <a
        href={mailTo}
        onClick={() => trackLinkClick("Email my results", mailTo)}
        className="lc-flex lc-items-center lc-text-white hover:lc-underline hover:lc-underline-offset-4"
      >
        <img src={Email} alt="Email icon" className="lc-h-4 lc-mr-2 lc-mt-1" />
        <span className="lc-font-azo-sans">Email my results</span>
      </a>
      <a
        href="#"
        onClick={handleReload}
        className="lc-flex lc-items-center lc-text-white hover:lc-underline hover:lc-underline-offset-4"
      >
        <img src={Refresh} alt="Restart icon" className="lc-h-6 lc-mr-2" />
        <span className="lc-font-azo-sans">Restart the quiz</span>
      </a>
    </div>
  );
};

export default NextSteps;
